
interface Jobs {
  [key: string]: {
    jobScreen: string
    meta?: { [key: string]: string }
  };
}
interface JobScreens {
  [key: string]: {
    latestRequestId: string;
    refresh: boolean
    eventMeta?: any
  };
}

interface OperationResult {
  timestamp: number
  state: string
  result: any
}

interface Operation {
  requestId: string
  operation?: string
  latestResult?: OperationResult
  results?: OperationResult[]
}

interface Operations {
  [key: string]: Operation
}

interface InitialState {
  jobs: Jobs;
  jobScreens: JobScreens;
  operations: Operations
  operationsUpdated: boolean
}

const initial_state: InitialState = {
  jobs: {},
  jobScreens: {},
  operations: {},
  operationsUpdated: false
};
export function realtimeJob
    (state = initial_state, action: any) {
    const payload = action.data
    switch (action.type) {
        case 'INITIATE_OPERATION': {
          if (!payload.requestId)
            return {...state}
          if (!payload.operation)
            return {...state}
          const operation: Operation = {
            requestId: payload.requestId,
            operation: payload.operation,
            results: []
          }
          state.operations[payload.requestId] = operation
          return {...state}
        }
        break
        case 'OPERATION_EVENT':{
          const {requestId, state: operationState, result } = payload
          if (!requestId) return { ...state }
          if (!operationState) return { ...state }
          const operation: Operation = state.operations[requestId]
          if (!operation) return state // deliberately avoiding a refresh
          const operationResult: OperationResult = {
            timestamp: Date.now(),
            state: operationState,
            result
          }
          operation.latestResult = operationResult
          operation.results = operation.results || []
          operation.results.push(operationResult)
          state.operationsUpdated = true
          return { ...state }
        }
        break
        case 'CLEAR_LATEST_OPERATION_EVENT': {
          const { requestId } = payload
          if (!requestId) return { ...state}
          const operation : Operation = state.operations[requestId] 
          if (!operation) return { ...state}
          delete operation.latestResult
          state.operationsUpdated = false
          return {...state}
        }
        break
        case 'COMPLETE_OPERATION_EVENT': {
          const { requestId } = payload
          if (!requestId) return { ...state}
          delete state.operations[requestId]
          state.operationsUpdated = false
          return {...state}
        }
        break
        case 'INITIATE_BACKGROUND_JOB':
          if (!payload.requestId) { 
            return {...state }
          } else {
            state.jobs[payload.requestId] = { jobScreen: payload.jobScreen, meta: payload.meta }
            state.jobScreens[payload.jobScreen] = { latestRequestId: payload.requestId, refresh: false }
            return {
              ...state
            };
          }
        case 'REFRESH_SCREEN':
          const refreshJob = state.jobs[payload.requestId]
          if(refreshJob){
            state.jobScreens[refreshJob.jobScreen].refresh = true
            state.jobScreens[refreshJob.jobScreen].eventMeta = payload.eventMeta
          }
          return { 
            ...state
          }            
        case 'COMPLETE_BACKGROUND_JOB':
          const job = state.jobs[payload.requestId]
          if(job){
            delete state.jobScreens[job.jobScreen]
            delete state.jobs[payload.requestId]
          }
          return { 
            ...state
          }  
        default:
            return state;
    }
}
